<!-- Hero with text on left half -->

<template>
    <!-- Hero Banner Section -->   
    <section class="relative">        
      <UiArticleImage :fit="'crop'" :modifiers="modifiers" v-if="article.image" :article="article" />
        <UiContentwrapper class="contentwrapper absolute flex justify-center items-center inset-0">
          <UiNarrowColumnLeft v-if="article.excerpt">
            <h2 class="hero-excerpt m-0 text-white" v-html="article.excerpt"></h2>
        </UiNarrowColumnLeft>
        </UiContentwrapper>
    </section>  
      <!-- Display the content under the image -->
      <UiExtraNarrowContent v-if="article.content">
        <p class="large">{{ article.content }}</p>
      </UiExtraNarrowContent>
    
  </template>
  
  <script setup>
  import { useBlogStore } from '@/stores/blogStore';
  
  const blogStore = useBlogStore();
  
  
  import { computed } from 'vue';
  
  const modifiers = computed(() => {
    if(blogStore.articleHasTag(props.article, 'Tall')) {
      return { auto: 'format,compress', ar: '1440:800' };
    }else{
      return { auto: 'format,compress', ar: '1440:600' };
    }
  
  });
  // Props
  const props = defineProps({
    article: {
      type: Object,
      required: true,
    }
  });
  
  
  
  </script>


<style scoped>
@reference "../../assets/css/main.css";

/* Adjust font sizes for smaller screens */
@media (max-width: 768px) {
  .hero-excerpt {
    @apply text-xl;
  }
}

@media (max-width: 400px) {
  .hero-excerpt {
    @apply text-sm;
  }
}
</style>